"use client";

import React, { ReactElement } from "react";

import HelpOverlayButton from "@/app/shared-components/help-overlay-button/help-overlay-button";
import ActionButton from "@/components/molecules/action-button/action-button";
import Logo from "@/components/molecules/logo-component/logo";
import useMediaQuery from "@/hooks/use-media-query/use-media-query-enhanced";
import { usePolicyExtrasAction } from "@/providers/policy-extras-action-provider";
import RenewalStateProvider from "@/providers/renewal-state-provider";

import withQuoteData from "../with-quote-data";

interface RenwalWrapperProps {
  renewalsHeaderBanner: ReactElement;
  middlePanel: ReactElement;
  continueCtaLable: string;
  loaderData?: {
    title: string;
    mobileContent: string[];
    desktopContent: string[];
  };
  isLoading?: boolean;
}

function RenewalsPolicyExtrasPageLayoutWrapper({
  renewalsHeaderBanner,
  middlePanel,
  continueCtaLable,
}: Readonly<RenwalWrapperProps>) {
  const [isdesktop, isReady] = useMediaQuery("(min-width: 600px)");
  const { handlePolicyExtrasSubmit, isShowCTABtnLoading } =
    usePolicyExtrasAction();

  if (!isReady) return null;

  const handleBackClick = () => {};

  return (
    <div
      data-testid="renewals-page-test-id"
      className="bg-surface-neutral-option-2 "
    >
      <div className="max-w-[1200px] mx-auto my-0 w-[100%] relative min-h-[calc(100vh-12px)] md:pb-0 pb-spacing-5xl ">
        <header className="md:py-spacing-l lg:py-spacing-xxl pt-spacing-m pb-spacing-m">
          <div
            className=" md:gap-spacing-l gap-spacing-m xl:mx-auto lg:mx-[72px]
      md:mx-[48px] mx-[24px] relative"
          >
            <div className="bg-dark-surface-accent-1-primary rounded-radius-xxl">
              <div className="flex flex-col h-full ">
                <div className="text-surface-neutral-option-1 relative">
                  <HelpOverlayButton />
                  <Logo
                    color="white"
                    heightClass="h-[80px]"
                    size="xl"
                    showondesktop={isdesktop.toString()}
                  />
                </div>
                {renewalsHeaderBanner}
              </div>
            </div>
          </div>
        </header>
        <main className="xl:mx-auto lg:mx-[72px] mb-spacing-l lg:mb-0">
          {sessionStorage.getItem("isSession") === "true" && (
            <RenewalStateProvider isLoading={false}>
              {middlePanel}
            </RenewalStateProvider>
          )}
        </main>
        <div className="mx-auto md:grid w-fit justify-center">
          <footer className="w-full md:w-[342px] mx-auto lg:mb-spacing-6xl md:mb-spacing-xxl sm:py-spacing-m flex flex-col justify-start items-center">
            <ActionButton
              page="renewal"
              showBackBtn={false}
              backButtonClick={handleBackClick}
              ctaButtonText={continueCtaLable}
              disableMain={false}
              submitButtonClick={handlePolicyExtrasSubmit}
              isLoading={isShowCTABtnLoading}
            />
          </footer>
        </div>
      </div>
    </div>
  );
}

export default withQuoteData(RenewalsPolicyExtrasPageLayoutWrapper);
